import React from 'react';
import bytes from 'bytes';
import ReactDOM from 'react-dom';
import { Field } from 'redux-form';
import format from 'string-template';
import { PropTypes } from 'prop-types';
import { remove, isEqual, toLower } from 'lodash';

import {
    FormInputContainerComponent,
    ItemComponent,
    InputComponent
} from '../InputWrappersComponent';
import { required } from 'redux-form-validators';
import FileListComponent from './FileListComponent';
import ButtonComponent from '../../button/ButtonComponent';
import { getFileExtension } from '../../../utils/fileUtils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

const initialErrorState = {
    fileAlreadyAdded: false,
    unauthorizedExtension: false,
    maxSizeExceededMessage: false
};

const ErrorContainer = ({ message }) => <p className="color-err small">{message}</p>;

class RenderFilesInputFieldComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            ...initialErrorState
        };
    }

    onFileChange = event => {
        const { input, formatAccepted, maxSize } = this.props;
        const { files } = this.state;
        event.preventDefault();
        const newFile = event.target.files[0];
        // check if a file with the same name has been already added
        if (!formatAccepted.includes(toLower(getFileExtension(newFile.name)))) {
            this.setState({ unauthorizedExtension: true });
        } else if (newFile.size > bytes(`${maxSize}MB`)) {
            this.setState({ maxSizeExceededMessage: true });
        } else if (
            files
                .reduce((res, curr) => {
                    res.push(curr.name);
                    return res;
                }, [])
                .includes(newFile.name)
        ) {
            this.setState({ fileAlreadyAdded: true });
        } else {
            files.push(newFile);
            this.setState({ files, ...initialErrorState });
            input.onChange(files);
        }
    };

    renderFileAlreadyAddedMessage = () =>
        this.state.fileAlreadyAdded && (
            <ErrorContainer message={this.props.i18nFeatureForm.FILE_ALREADY_ADDED} />
        );
    renderUnauthorizedExtensionMessage = () =>
        this.state.unauthorizedExtension && (
            <ErrorContainer message={this.props.i18nFeatureForm.FILE_EXTENSION_UNAUTHORIZED} />
        );
    renderMaxSizeExceededMessage = () =>
        this.state.maxSizeExceededMessage && (
            <ErrorContainer message={this.props.i18nFeatureForm.FILE_SIZE_EXCEEDED} />
        );

    renderHint = () => (
        <p>
            {convertHtmlToReactDomWithParams(
                `${this.props.btHint ? `${this.props.btHint}<br/>` : ''}${
                    this.props.i18nFeatureForm.FILE_HINT_DEFAULT
                }`,
                this.props.formatAccepted.join(', '),
                this.props.maxSize
            )}
        </p>
    );

    openFileChooser = event => {
        ReactDOM.findDOMNode(this.refs.inputFile.refs.input).click();
    };

    onRemoveFile = file => {
        const { input } = this.props;
        const files = this.state.files;
        // remove return an array with element removed so we use the array param
        remove(files, el => isEqual(file.name, el.name));
        this.setState({ files });
        input.onChange(files);
    };

    render() {
        const { meta, isMultiple, btColor, btText, classNameInputContainer } = this.props;
        const { files } = this.state;
        // ReduxForm doesnt handle correctly file input. Reduxform return
        // an object to input value and HTML doesnt accept an object in
        // input file value so web have to force the value to null
        let { input } = this.props;
        input.value = '';
        return (
            <FormInputContainerComponent
                className={classNameInputContainer ? classNameInputContainer : ''}>
                <ItemComponent className="item  item-file">
                    <ButtonComponent
                        text={btText}
                        color={btColor ? btColor : 'main'}
                        onClick={this.openFileChooser.bind(this)}
                    />
                    <InputComponent
                        {...this.props}
                        type="file"
                        id={input.name}
                        ref="inputFile"
                        placeholder=""
                        multiple={isMultiple}
                        className="input-file color1"
                        onChange={this.onFileChange.bind(this)}
                    />
                    <FileListComponent files={files} onRemoveFile={this.onRemoveFile.bind(this)} />
                    {this.renderFileAlreadyAddedMessage()}
                    {this.renderUnauthorizedExtensionMessage()}
                    {this.renderMaxSizeExceededMessage()}
                    {this.renderHint()}
                    {meta.touched && meta.error && <ErrorContainer message={meta.error} />}
                </ItemComponent>
            </FormInputContainerComponent>
        );
    }
}

class FilesInputFieldComponent extends React.Component {
    render() {
        const { validate, i18nFeatureForm, minRequired } = this.props;
        return (
            <Field
                {...this.props}
                validate={
                    validate
                        ? validate
                        : minRequired
                          ? [
                                required({
                                    msg: format(
                                        i18nFeatureForm.FILE_REQUIRED,
                                        minRequired,
                                        minRequired > 1 ? 's' : ''
                                    )
                                })
                            ]
                          : []
                }
                component={RenderFilesInputFieldComponent}
            />
        );
    }
}

/**
 * isMultiple : boolean, input accept more than one files
 * formatAccepted : string, files extensions accepted, ex.: ['html', 'png']
 * maxSize: file size in MB
 */
FilesInputFieldComponent.propTypes = {
    isMultiple: PropTypes.bool,
    formatAccepted: PropTypes.array.isRequired,
    maxSize: PropTypes.number.isRequired,
    minRequired: PropTypes.number,
    btColor: PropTypes.string,
    btText: PropTypes.string.isRequired,
    btHint: PropTypes.string,
    i18nFeatureForm: PropTypes.object
};

export default FilesInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/fileInput/FilesInputFieldComponent.js